import React, { useState, useEffect } from 'react';
import Body_about from '../components/about_me.js';



function About_me() {
    return (
        <main>
            <Body_about />
        </main>

    );
}

export default About_me;